import React, { useEffect, useState, useRef, act } from "react";
import "../stories/stories.css";
import StoriesService  from "../../services/StoriesService";  
import { toast } from "react-toastify";
import QuestionsList from "./QuestionsList";

const Stories = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [stories, setStories] = useState(null);

  const [activeStory, setActiveStory] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [orderModified, setOrderModified] = useState(false);
  const [requestSubmitted, setRequestSubmitted] = useState(false);


  const handleIconClick = (index) => {
    console.log("Index: ", index, " Active index: ", activeIndex);
    if (index === activeIndex) {
      setActiveIndex(null);
    } else {
      setActiveIndex(null); //Do this to clear the modal and re-render it
      setActiveIndex(index);
    }
    console.log("Active Index: ", activeIndex);
    console.log(stories[activeIndex]);
  };

  const handleEditStory = async (event) => {
    setRequestSubmitted(true)
    try {
      console.log("Updating story");
      event.preventDefault();
      const formData = new FormData(event.target);
      const title = formData.get("title");
      const url = formData.get("url");
      const subtitle = formData.get("subtitle");
      console.log(formData);
      const thumbnail = formData.get("thumbnail");
      const response = await StoriesService.updateStory(stories[activeIndex]?.id, activeIndex + 1, url, title, subtitle, thumbnail);
      if (response) {
        toast.success("Story updated");
        window.location.reload();
      }
    } catch (error) {
      toast.error(`Error Code: ${error.response.data.code}`);      
      console.error(error);
    }
    setRequestSubmitted(false)
  };

  const getAllStories = async () => {
    try {
      const response = await StoriesService.getStories();
      if (response) {
        setStories(response);
      }
    } catch (error) {
      toast.error(`Error Code: ${error.response.data.code}`);
      console.error(error);
    }
  };

  const deleteStory = async (story) => {
    try {
      if (window.confirm("Are sure you want to delete story ??")) {
        const response = await StoriesService.deleteStory(story);
        if (response) {
          toast.success("Story deleted");
          getAllStories();
          setActiveIndex("");
        }
      }
    } catch (error) {
      toast.error(`Error Code: ${error.response.data.code}`);
      console.error(error);
    }
  };

  const moveUpStory = function(index) {
    var tempArr = [...stories]
    var temp = tempArr[index];
    tempArr[index] = tempArr[index - 1];
    tempArr[index - 1] = temp;
    setStories(tempArr)
    setOrderModified(true)
  }

  const moveDownStory = function(index) {
    var tempArr = [...stories]
    var temp = tempArr[index];
    tempArr[index] = tempArr[index + 1];
    tempArr[index + 1] = temp;
    setStories(tempArr)
    setOrderModified(true)
  }

  const saveOrder = async function() {
    setRequestSubmitted(true)
    for (let index = 0; index < stories.length; index++) {
      stories[index].order = index + 1;
    }
    
    await StoriesService.updateStoryOrders(stories);

    toast.success("Story Order Saved");
    setRequestSubmitted(false);
    setOrderModified(false);
  }

  const handleUploadStory = async (event) => {
    setRequestSubmitted(true)
    try {
      event.preventDefault();
      const formData = new FormData(event.target);
      const url = formData.get("url");
      const title = formData.get("title");
      const subtitle = formData.get("subtitle");
      const thumbnail = formData.get("thumbnail");
      const response = await StoriesService.addStory(stories.length + 1, url, title, subtitle, thumbnail);
      if (response) {
        toast.success("Story Added");
        window.location.reload();
      }
    } catch (error) {
      toast.error(`Error Code: ${error.response.data.code}`);
      console.error(error);
    }
    setRequestSubmitted(false)
  };

  useEffect(() => {
    getAllStories();
    console.log("useEffect() called");
  }, []);

  return (
    <div className="container">
      <div className="overview d-flex justify-content-between align-items-center">
        <div className="title">
          <ion-icon name="people-outline"></ion-icon>
          <span className="text">Stories</span>
        </div>

        <button
          className="btn-header d-flex align-items-center gap-1"
          data-bs-target="#uploadModal"
          data-bs-toggle="modal"
        >
          <ion-icon name="add-outline"></ion-icon>
          Upload
        </button>
      </div>

      <div className="data-table activityTable">
        <div className="tableStyle">
          <table>
            <thead>
              <tr>
                <th className="users-th">No</th>
                {/* <th className="users-th">Admin</th> */}
                <th className="users-th">Title</th>
                {/* <th className="users-th">Thumbnail</th> */}
                <th className="users-th">Video</th>
                <th style={{ width: "10%" }} className="users-th">
                  Action
                </th>
                <th>Reorder</th>
              </tr>
            </thead>
            <tbody>
              {stories?.map((story, index) => (
                <tr key={index}>
                  <td className="users-td" key={index}>
                    {index + 1}
                  </td>
                  {/* <td className="users-td">
                    <div>{user.name}</div>
                  </td> */}
                  <td className="users-td">{story.title}</td>
                  {/* <td className="users-td">
                    <img
                      src={BASE_URL + story.thumbnailUrl}
                      style={{ height: "50px" }}
                      alt = "The story thumbnail"
                    />
                  </td> */}
                  <td className="users-td">
                    <a target="_blank" href={story.url} rel="noreferrer"> Video Link </a>
                  </td>

                  <td className="users-td">
                    <ion-icon
                      name="ellipsis-vertical-outline"
                      id="userAction"
                      onClick={() => handleIconClick(index)}
                      style={{ cursor: "pointer" }}
                    ></ion-icon>
                    {activeIndex === index && (
                      <div className="showOption-story">
                        {/* <NavLink
                          to={`/view-story/${story.id}`}
                          className="removeTextDecoration"
                        >
                          <p className="pt-3 d-flex align-items-center gap-2">
                            <ion-icon name="eye-outline"></ion-icon> View
                          </p>
                        </NavLink> */}
                        <p
                          className="d-flex align-items-center gap-2"
                          //data-bs-target="#editModal"
                          //data-bs-toggle="modal"
                          onClick={() => setShowEditModal(true)}
                        >
                          <ion-icon name="create-outline"></ion-icon> Edit
                        </p>
                        <p
                          className="d-flex align-items-center gap-2"
                          style={{ color: "red" }}
                          onClick={() => deleteStory(story.id)}
                        >
                          <ion-icon name="trash-outline"></ion-icon> Delete
                        </p>

                        {/* <p
                          className="d-flex align-items-center gap-2"
                          data-bs-target="#QuestionsList"
                          data-bs-toggle="modal"
                          style={{ color: "black" }}
                          onClick={() => setActiveStory(story.id)}
                        >
                          <ion-icon name="help-circle-outline"></ion-icon>
                          Questions
                        </p> */}
                      </div>
                    )}
                  </td>
                  <td>
                    <button
                      disabled={index === 0}
                      onClick={() => moveUpStory(index)}
                    >
                      ^
                    </button>
                    <button 
                      disabled={index === stories.length - 1}
                      onClick={()=> moveDownStory(index)}
                    >
                      v
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Sort Question */}

          <div
            className="modal fade"
            id="QuestionsList"
            aria-hidden="true"
            aria-labelledby="exampleModalToggleLabel"
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                    Questions
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <QuestionsList story={activeStory} />
                </div>
              </div>
            </div>
          </div>

          {/* Edit Modal */}
          {showEditModal &&
          <div className="bg-black"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1001
          }}>
            <div
              className="modal fade show"
              style={{
                display: "block",
              }}
              //id="editModal"
              //aria-hidden="true"
              //aria-labelledby="exampleModalToggleLabel"
              //tabindex="-1"
            >
              <form onSubmit={handleEditStory}>
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h1
                        className="modal-title fs-5"
                        id="exampleModalToggleLabel"
                      >
                        Edit Story
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        //data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setShowEditModal(false)}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="mb-3">
                        <label htmlFor="recipient-name" className="col-form-label">
                          Title
                        </label>
                        <input
                          type="text"
                          className="form-control truncate"
                          id="recipient-name"
                          placeholder="Title"
                          name="title"
                          defaultValue={stories[activeIndex].title}
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="recipient-name" className="col-form-label">
                          Subtitle
                        </label>
                        <input
                          name="subtitle"
                          type="text"
                          className="form-control truncate"
                          id="recipient-name"
                          placeholder="Subtitle"
                          defaultValue={stories[activeIndex].subtitle}
                        />
                      </div>
                      {/* <div className="mb-3">
                        <label for="recipient-name" className="col-form-label">
                          Title B
                        </label>
                        <input
                          name="titleB"
                          type="text"
                          className="form-control truncate"
                          id="recipient-name"
                          placeholder="Title B"
                          defaultValue={story.titleB}
                        />
                      </div> */}
                      {/* <div className="mb-3">
                        <label for="recipient-name" className="col-form-label">
                          Thumbnail
                        </label>
                        <DropzoneThumbnail
                          onFileUpload={setThumbnailUrl}
                          title="thumbnail"
                          accept={{
                            "image/*": [],
                          }}
                        />
                      </div> */}
                      {/* <div className="mb-3">
                        <label for="recipient-name" className="col-form-label">
                          Story Video
                        </label>
                        <div {...getRootProps({ className: dropzoneClass })}>
                        <input {...getInputProps()} />
                        <div className="p-2">
                          Drop or select story video here...
                        </div>
                      </div>
                        <DropzoneVideo onVideoSelect={setVideoUrl} />
                      </div> */}
                      {/* <div className="mb-3">
                        <label for="recipient-name" className="col-form-label">
                          Type
                        </label>
                        <select
                          defaultValue={story.type}
                          className="form-control"
                          name="type"
                        >
                          <option value={"Story"}> Story </option>
                          <option value={"Landing"}> Landing Stroy </option>
                        </select>
                      </div> */}
                      {/* <div className="mb-3">
                        <label className="col-form-label">
                          Whether to Host
                        </label>
                        <select
                          name="whetherToHost"
                          className="form-select"
                          aria-label="Default select example"
                        >
                          <option
                            selected={story.whetherToHost === "Local" && true}
                            value="Local"
                          >
                            Local
                          </option>
                          <option
                            selected={story.whetherToHost === "Vimeo" && true}
                            value="Vimeo"
                          >
                            Vimeo
                          </option>
                          <option
                            selected={story.whetherToHost === "YouTube" && true}
                            value="YouTube"
                          >
                            YouTube
                          </option>
                        </select>
                      </div> */}
                      <div className="mb-3">
                        <label htmlFor="recipient-name" className="col-form-label">
                          Story Link
                        </label>
                        <input
                          name="url"
                          type="text"
                          className="form-control truncate"
                          id="recipient-name"
                          placeholder="Enter story link"
                          defaultValue={stories[activeIndex].url}
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="thumbnail" className="col-form-label">
                          Thumbnail
                        </label>
                        <input
                          name="thumbnail"
                          type="file"
                          className="form-control truncate"
                          id="thumbnail"
                        />
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        id="edit-story"
                        className="btn-model"
                        type="submit"
                        disabled={requestSubmitted && true}
                        // data-bs-target="#exampleModalToggle2"
                        // data-bs-toggle="modal"
                      >
                        {!requestSubmitted ? 
                          <>Save</> :
                          <div className="loadingIndicator"></div>
                        }
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          }

          {/* Upload Modal */}
          <div>
            <div
              className="modal fade"
              id="uploadModal"
              aria-hidden="true"
              aria-labelledby="exampleModalToggleLabel"
              tabindex="-1"
              // ref={uploadModalRef}
            >
              <form onSubmit={handleUploadStory}>
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h1
                        className="modal-title fs-5"
                        id="exampleModalToggleLabel"
                      >
                        Upload Story
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="mb-3">
                        <label htmlFor="recipient-name" className="col-form-label">
                          Title
                        </label>
                        <input
                          type="text"
                          className="form-control truncate"
                          id="recipient-name"
                          placeholder="Title"
                          name="title"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="recipient-name" className="col-form-label">
                          Subtitle
                        </label>
                        <input
                          name="subtitle"
                          type="text"
                          className="form-control truncate"
                          id="recipient-name"
                          placeholder="Subtitle"
                        />
                      </div>
                      {/* <div className="mb-3">
                        <label for="recipient-name" className="col-form-label">
                          Title B
                        </label>
                        <input
                          name="titleB"
                          type="text"
                          className="form-control truncate"
                          id="recipient-name"
                          placeholder="Title B"
                        />
                      </div> */}
                      {/* <div className="mb-3">
                        <label for="recipient-name" className="col-form-label">
                          Thumbnail
                        </label>
                        <DropzoneThumbnail
                          onFileUpload={setThumbnailUrl}
                          title="thumbnail"
                          accept={{
                            "image/*": [],
                          }}
                        />
                      </div> */}
                      {/* <div className="mb-3">
                        <label for="recipient-name" className="col-form-label">
                          Story Video
                        </label>
                        <DropzoneVideo onVideoSelect={setVideoUrl} />
                      </div> */}
                      {/* <div className="mb-3">
                        <label for="recipient-name" className="col-form-label">
                          Type
                        </label>
                        <select className="form-control" name="type">
                          <option value={"Story"}> Story </option>
                          <option value={"Landing"}> Landing Stroy </option>
                        </select>
                      </div> */}
                      {/* <div className="mb-3">
                        <label className="col-form-label">
                          Whether to Host
                        </label>
                        <select
                          name="whetherToHost"
                          className="form-select"
                          aria-label="Default select example"
                        >
                          <option value="Local">Local</option>
                          <option value="Vimeo">Vimeo</option>
                          <option value="YouTube">YouTube</option>
                        </select>
                      </div> */}
                      <div className="mb-3">
                        <label htmlFor="recipient-name" className="col-form-label">
                          Story Link
                        </label>
                        <input
                          name="url"
                          type="text"
                          className="form-control truncate"
                          id="recipient-name"
                          placeholder="Enter story link"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="thumbnail" className="col-form-label">
                          Thumbnail
                        </label>
                        <input
                          name="thumbnail"
                          type="file"
                          className="form-control truncate"
                          id="thumbnail"
                        />
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        id="upload-story"
                        className="btn-model"
                        type="submit"
                        disabled={requestSubmitted && true}
                        // data-bs-target="#exampleModalToggle2"
                        // data-bs-toggle="modal"
                      >
                        {!requestSubmitted ?
                          <>Upload Story</> :
                          <div className="loadingIndicator"></div> 
                        }
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


      {orderModified && 
      <button
        className="mt-4 btn-model"
        onClick={() => saveOrder()}
      >
        {!requestSubmitted ? 
        <>Save Story Order</> :
        <div className="loadingIndicator"></div>
        }
      </button>
      }
    </div>
  );
};

export default Stories;
